export default __webpack_public_path__ + "static/media/infographic-quiz-false.163fdb36.svg";